<template>
  <div id="app_content" class="public">
<!--    <universal_filter @treePass="treeLoad"></universal_filter>-->
    <div class="container-fluid">
      <div class="jumbo">
        <div
            v-if="isMounted"
            :style="
            'background-image: url(' +
            url('/media/vetrina/bg/' + cod_macro + '.jpg') + ');' ">
        </div>


      </div>
      <div class="body">
        <div class="row">
          <!-- METTERE QUI IL NUOVO CONTENUTO -->
          <div
              class="col-md-12 other-macro text-green"
              v-if="macroMounted" >
            <a :href="url('/catalog/' + otherMacro.link )" >
              {{trans.get('public.macro.discover')}} {{ ($store.state.current_lang === 'it') ? otherMacro.text_it : otherMacro.text_eng }}
              <span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25.45"
                            height="11.322"
                            viewBox="0 0 25.45 11.322"
                        >
                          <g
                              id="Raggruppa_269"
                              data-name="Raggruppa 269"
                              transform="translate(-626.257 -107.125)"
                          >
                            <path
                                id="Tracciato_94"
                                data-name="Tracciato 94"
                                d="M-293.192,276.7l4.346-3.022a2.682,2.682,0,0,0-.014-4.5l-4.331-2.975"
                                transform="translate(938.836 -158.66)"
                                fill="none"
                                stroke="#abc932"
                                stroke-miterlimit="10"
                                stroke-width="1"
                            />
                            <line
                                id="Linea_13"
                                data-name="Linea 13"
                                x1="24.858"
                                transform="translate(626.257 112.81)"
                                fill="none"
                                stroke="#abc932"
                                stroke-miterlimit="10"
                                stroke-width="1"
                            />
                          </g>
                        </svg>
                      </span>
            </a>
          </div>
          <div class="col-md-12 mt-3 mb-3" v-if="families">
            <h1 class="my-caps macro-titolo">
              {{ families[0].macrofamily.descrizione }}
            </h1>
          </div>
          <div class="col-md-12 col-xl-8 macro-descrizione" v-if="families">
            <p>
              {{ trans.get('public.macro.'+ families[0].macrofamily.codice.toLowerCase())}}
            </p>
          </div>
        </div>
        <div class="row family-container" v-if="mounted">
          <div
              class="col-md-4 mt-4"
              v-for="(fam, i) in families"
              :key="i" v-if="fam.codice !== 'POL' && fam.codice !== 'CUS'"
          >
            <famCard

                :macro="cod_macro"
                :codice="fam.codice"


                :descrizione="fam.descrizione"
            />
          </div>
        </div>
      </div>
      <div class="bottom">
        <form_newsletter_new/>
      </div>
    </div>
    <!--      <div class="section top fp-section fp-table active fp-completely">
            <div
                v-if="isMounted"
                class="inner-section inner-top"
                :style="
                'background-image: url(' +
                url('/media/vetrina/bg/' + cod_macro + '.jpg') + ');' ">
              <div class="section-container h-100">
                <div class="my-content h-100">
                  <div class="container h-100"></div>
                </div>
              </div>
            </div>
            <div class="inner-section inner-bottom">
              <div class="section-container h-100">
                <div class="my-content h-100">
                  <div class="container ">
                    <div class="row">
                      &lt;!&ndash; METTERE QUI IL NUOVO CONTENUTO &ndash;&gt;
                      <div
                          class="col-md-12 other-macro text-green"
                          v-if="macroMounted"
                      >
                        <a :href="url('/catalog/' + otherMacro.link)"
                        >Scopri anche {{ otherMacro.text }}
                          <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25.45"
                                height="11.322"
                                viewBox="0 0 25.45 11.322"
                            >
                              <g
                                  id="Raggruppa_269"
                                  data-name="Raggruppa 269"
                                  transform="translate(-626.257 -107.125)"
                              >
                                <path
                                    id="Tracciato_94"
                                    data-name="Tracciato 94"
                                    d="M-293.192,276.7l4.346-3.022a2.682,2.682,0,0,0-.014-4.5l-4.331-2.975"
                                    transform="translate(938.836 -158.66)"
                                    fill="none"
                                    stroke="#abc932"
                                    stroke-miterlimit="10"
                                    stroke-width="1"
                                />
                                <line
                                    id="Linea_13"
                                    data-name="Linea 13"
                                    x1="24.858"
                                    transform="translate(626.257 112.81)"
                                    fill="none"
                                    stroke="#abc932"
                                    stroke-miterlimit="10"
                                    stroke-width="1"
                                />
                              </g>
                            </svg>
                          </span>
                        </a>
                      </div>
                      <div class="col-md-12 mt-3 mb-3" v-if="macro">
                        <h1 class="my-caps macro-titolo">
                          {{ macro.descrizione }}
                        </h1>
                      </div>
                      <div class="col-md-12 col-xl-8 macro-descrizione">
                        <p>
                          4-belt produce cinghie termosaldanti in poliuretano per la
                          movimentazione, con impieghi in tutti i settori
                          industriali, dal settore ceramico al settore alimentare,
                          dal settore legno al settore vetro, ad infiniti altri
                          campi applicativi.
                        </p>
                        <p>
                          4-belt utilizza per la produzione delle cinghie solo ed
                          esclusivamente un polimero TPU assolutamente puro, un
                          materiale certificato, appositamente progettato per
                          l’estrusione e perfettamente rispondente alle normative
                          richieste nei vari campi di applicazione quali ad esempio
                          le normative FDA/EC nel campo alimentare.
                        </p>
                      </div>
                    </div>
                    <div class="row family-container" v-if="mounted">
                      <div
                          class="col-md-4 mt-4"
                          v-for="(fam, i) in families"
                          :key="i" v-if="fam.codice !== 'POL' && fam.codice !== 'CUS'"
                      >
                        <famCard

                            :macro="cod_macro"
                            :codice="fam.codice"
                            :active="active === fam.codice"
                            @active="setActive"
                            :descrizione="fam.descrizione"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section std d-flex is-flex-direction-column">
            <div class="inner-section newsletter">
              <div class="section-container">
                <div class="my-content">
                  <form_newsletter_new />
                </div>
              </div>
            </div>
          </div>-->


  </div>
</template>

<script>
//https://github.com/gs-shop/vue-slick-carousel/blob/master/docs/API.md#props

// import Login from './../login'
// import Login from './../form-contact'
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueFullPage from "vue-fullpage.js";
import breadcrumb from "./components/breadcrumb";
import families from "./components/families";
import catcolor from "./components/cat-color";
import filterProds from "./components/filter";
import universal_filter from "../../reserved/universal-filter";
import famCard from "./components/fam-card";
import form_newsletter_new from "./../form-newsletter-new"

export default {
  name: "macro",
  components: {
    /*Login ,*/ VueFullPage,
    "v-slick": VueSlickCarousel,
    breadcrumb,
    families,
    catcolor,
    filterProds,
    universal_filter,
    famCard,
    form_newsletter_new
  },

  data: function () {
    return {
      opened_float_login: false,
      mounted: false,
      cod_macro: null,
      families: null,
      active: null,
      catColor: false,
      breadKey: 0,
      otherMacro: null,
      catColorKey: 0,
      tree: null,
      macro: null,

      optionsFullPage: {
        licenseKey: "Ululab21-key00001-FullPage-ScrollPG",
        navigation: true,
        controlArrows: true,
        scrollBar: false,
        loopBottom: false,
        responsiveWidth: 1220,

        //events
        onLeave: function (origin, destination, direction) {
          let fpNav = document.getElementById("fp-nav");
          if (fpNav) {
            if (destination.isFirst) {
              fpNav.classList.remove("active-prev");
              fpNav.classList.add("active-next");
            } else if (destination.isLast) {
              fpNav.classList.remove("active-next");
              fpNav.classList.add("active-prev");
            } else {
              fpNav.classList.add("active-prev");
              fpNav.classList.add("active-next");
            }
          }
        },
        afterRender: function () {
          let fpNav = document.getElementById("fp-nav");
          if (fpNav) {
            fpNav.classList.remove("active-prev");
            fpNav.classList.add("active-next");
          }
        },
      },
      macroMounted: false,

      isMounted: false,
      slickOptions: {
        lockAnchors: true,

        focusOnSelect: false,
        rtl: false,
        draggable: false,
        slidesToShow: 3,
        centerMode: true, //
        swipeToSlide: false,
        touchMove: false,
        infinite: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      familyMounted: false,

    };
  },
  watch: {
    "$store.state.catalog.catcolor": function () {
      this.catColorKey++;
    },
    tree: function () {
      this.macro = this.tree.find((element) => element.code === this.cod_macro);
    },
  },

  created: function () {
    // let vue = this;
    // setTimeout(function() {
    //   vue.isMounted = true;
    // }, 2000)
    // this.isMounted = true;
  },

  mounted: function () {
    //this.loadFamily();
    this.ifFam();
    this.spliceUrlMacro();
    this.calcOtherMacro();

    // this.setLockAnchors(true);
  },

  computed: {
    // this.tree.watch()
  },

  methods: {
    treeLoad: function (tree) {
      this.tree = tree;
      setTimeout(() => {
        this.macro = tree.find((element) => element == NAS);
        // console.log(this.tree);
      }, 1000);
    },

    ifFam: function () {
      let pathname = window.location.pathname.split("/");
       // console.log(pathname);
      if (pathname.length === 5) {
        let fam = pathname[4];
        this.active = fam;
        this.cod_macro = pathname[2];
        //console.log(fam)
      } else {
        this.cod_macro = pathname[pathname.length - 1];
      }
      // console.log(this.cod_macro);
      this.isMounted = true;
    },
    calcOtherMacro: function () {
      switch (this.cod_macro) {
        case "CIN":
          this.otherMacro = {
            text_it: "Accessori per Nastri Trasportatori",
            text_eng: "Conveyor's components",
            link: "NAS",
          };
          break;
        case "NAS":
          this.otherMacro = {
            text_it: "Cinghie Termosaldanti",
            text_eng: "Thermoweldable Belts",
            link: "CIN",
          };
      }
      this.macroMounted = true;
    },
    getCatColor: function () {
      axios({
        method: "get",
        url: window.location.origin + "/catalog/api/catcolor",
        params: {
          code: this.active,
        },
      }).then((res) => {
        //console.log('getCatColor', res.data)

        this.$store.commit("setCatColors", res.data);
        this.breadKey++;
        if (res.data.length > 0) {
          this.catColor = true;
        }
      });
    },
    setActive: function (index) {
      this.active = index;
      this.catColor = false;
      this.getCatColor();
    },
    spliceUrlMacro: function () {
      let pathname = window.location.pathname.split("/");
      this.cod_macro = pathname[pathname.length - 1];
      // console.log(this.cod_macro);
      this.getFamilies();
    },
    getFamilies: function () {
      axios({
        method: "get",
        url: window.location.origin + '/data/get-family',
        params: {
          // code: this.cod_macro,
          type: 'filter-f',
          cod: this.cod_macro,
          public: true,
        },
      })
          .then((res) => {
            this.families = res.data.family;
            // if (this.active === null) {
            //   this.active = this.families[0].codice;
            // }
            this.mounted = true;
          })
          .catch((err) => {
            console.log(err.response);

            console.log(err.response.data.message);
          });
    },

    scrollDown: function () {
      window.scrollBy(0, 100);
    },
    loadFamily: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: Object.keys(vue.macrofamily),
          type: "macro",
        },
      })
          .then((res) => {
            if (res.data.family) vue.macrofamily = res.data.family;
          })
          .catch((err) => {
            vue.loading = false;

            vue.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },

    lorem: function (p = 0) {
      let lorem =
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
      // let lastP = lorem.lastIndexOf('.');
      // return (p) ? lorem.slice(0, (p <= lastP) ? p : lastP ) : lorem;
      return lorem;
    },

    layoutText: function (v = 1) {
      switch (v) {
        case 1:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should tune “Germany” and “Austria” as countries. With corresponding success you can try out also further countries, for example Switzerland, and areas close to the border. This method can also be applied to any other language.";
          break;

        case 2:
        default:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should";
          break;
      }
    },
  },
};
</script>

<style lang="scss">

#app_content.public {
  font-size: 1em;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
  background-color: #25252a;
  h1, h2, h3, h5, h6 {
    font-size: revert;
    font-weight: normal;
  }
  h4 {
    font-weight: normal;
  }
  .my-caps.macro-titolo {
    font-size: 34px;
    margin: 30px 0;
  }
  .container-fluid {
    color: var(--text-white);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    .jumbo > div {
      height: calc(100vh / 3 + 80px);
      width: 100vw;
      background-repeat: no-repeat;
      background-size: cover;
      background-position-x: center;
    }
    .body {
      margin: 50px 0;
      margin-left: var(--public-menu-width);
      .row {
        max-width: 100%;
      }
      .family-container {
        //@media (min-width: 2000px){
        //  justify-content: center;
        //  max-width: 85%;
        //  margin: auto;
        //}
        //& > div {
        //  @media (min-width: 2000px){
        //    display: flex;
        //    margin-bottom: 40px;
        //  }
        // }
      }
      @media (max-width: 1200px){
        margin-left: 0;
      }

    }
    .bottom {

      background-color: rgb(14,14,14);
      display: flex;
      justify-content: center;
      padding-left: var(--public-menu-width);
      width: 100vw;
      >div {
        width: 100%;
        margin: 0;
      }
      @media (max-width: 1200px){
        padding-left: 0;
      }
    }


  }
}
</style>
<!--<style lang="scss">-->
<!--/*-->
<!-- * contenuto delle sezioni allineato togliendo l'ingombro-->
<!-- * del menù-->
<!--*/-->

<!--#app_content {-->
<!--  background-color: #25252a;-->
<!--  font-size: 14px;-->
<!--  height: fit-content;-->
<!--  .macro-titolo{-->
<!--    margin: 20px 0 15px;-->
<!--  }-->
<!--  .macro-descrizione {-->
<!--    margin-bottom: 20px;-->
<!--  }-->

<!--}-->
<!--.section.std {-->
<!--  padding: 0;-->
<!--}-->
<!--.inner-section {-->
<!--  width: 100vw;-->

<!--  &.newsletter {-->
<!--    background-color: #0e0e0e;-->
<!--    margin-top: auto;-->
<!--  }-->

<!--  .my-content > div {-->
<!--    padding: 0 20px;-->
<!--  }-->
<!--}-->
<!--h1,-->
<!--h2,-->
<!--h3,-->
<!--h4,-->
<!--h5,-->
<!--h6 {-->
<!--  font-size: revert;-->
<!--  font-weight: normal;-->
<!--}-->


<!--.section.top {-->
<!--  padding: 0;-->
<!--}-->


<!--.inner-top {-->
<!--  height: calc(100vh / 3 + 80px);-->
<!--  background-repeat: no-repeat;-->
<!--  background-size: cover;-->
<!--  background-position-x: center;-->
<!--}-->

<!--.inner-bottom {-->
<!--  height: fit-content;-->
<!--  padding: 2rem 0;-->
<!--  background-color: #25252a;-->
<!--}-->

<!--.famiglia {-->
<!--  background-color: #707070;-->
<!--}-->

<!--@media screen and (max-width: 1220px) {-->
<!--  .section .section-container {-->
<!--    max-width: 95%;-->
<!--    margin: auto;-->
<!--  }-->
<!--}-->

<!--/*-->
<!-- * payoff-->
<!--*/-->
<!--.payoff {-->
<!--  font-size: 60px;-->
<!--  font-weight: lighter;-->
<!--}-->

<!--@media screen and (max-width: 750px) {-->
<!--  .payoff {-->
<!--    font-size: 2.4em;-->
<!--  }-->
<!--}-->

<!--@media screen and (max-width: 400px) {-->
<!--  .payoff {-->
<!--    font-size: 2em;-->
<!--  }-->
<!--}-->

<!--.section.top,-->
<!--.section.bgi {-->
<!--  width: 100%;-->
<!--  height: 100vh;-->
<!--  color: white;-->
<!--  background-repeat: no-repeat;-->
<!--  background-origin: initial;-->
<!--  background-clip: initial;-->
<!--  background-size: cover;-->
<!--  background-position: initial;-->
<!--}-->

<!--.section.bgi {-->
<!--  background-size: contain;-->
<!--}-->

<!--.section-sub {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--}-->

<!--.section.std {-->
<!--  width: 100%;-->
<!--  height: 100vh;-->
<!--  background-color: var(&#45;&#45;black-2);-->
<!--}-->

<!--.section.top .content {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--}-->

<!--.section.top .content h1 {-->
<!--  font-size: 60px;-->
<!--  font-weight: lighter;-->
<!--}-->

<!--#app-scroll-->
<!--&gt; div.section.top.fp-section.active.fp-table.fp-completely-->
<!--&gt; div-->
<!--&gt; div-->
<!--&gt; div-->
<!--&gt; div-->
<!--&gt; img {-->
<!--  width: 420px;-->
<!--  height: 130px;-->
<!--}-->

<!--.section.top .fp-tableCell {-->
<!--  // width: calc(100vw - 250px);-->
<!--  height: 100% !important;-->
<!--  float: right;-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  flex-direction: column;-->
<!--  justify-content: center;-->
<!--}-->

<!--.section.top {-->
<!--  height: 100vh !important;-->

<!--  .section-container-center-mode {-->
<!--    height: 100%;-->
<!--    display: flex;-->
<!--    align-items: center;-->
<!--  }-->

<!--  .discover-button {-->
<!--    margin-top: auto;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--    align-items: center;-->
<!--    flex-direction: column;-->

<!--    .discover-text {-->
<!--      display: inline-block;-->
<!--      margin-bottom: 20px;-->
<!--    }-->
<!--  }-->
<!--}-->

<!--.section.std .content .text {-->
<!--  color: white;-->
<!--  width: 100%;-->
<!--  max-width: 95%;-->
<!--  width: 760px;-->
<!--  margin: auto;-->
<!--}-->

<!--.section.std .content .text h1 {-->
<!--  font-weight: 500;-->
<!--}-->

<!--.section.std .content .text p {-->
<!--  margin: 0;-->
<!--  font-weight: 300;-->
<!--  color: var(&#45;&#45;text-white);-->
<!--}-->

<!--.content-gallery {-->
<!--  width: 100%;-->
<!--  margin: auto;-->
<!--  position: relative;-->
<!--}-->

<!--.content-gallery .slick-slider {-->
<!--  margin-left: -180px;-->
<!--}-->

<!--.content-source-media {-->
<!--  width: auto;-->
<!--}-->

<!--.content-source-media .source {-->
<!--  width: inherit;-->
<!--}-->

<!--.content-source-media .source img {-->
<!--  display: block;-->
<!--  width: inherit;-->
<!--  padding: 2em;-->
<!--  transition: padding 0.2s 0.2s ease-in-out;-->
<!--}-->

<!--.slick-slide[aria-hidden="false"]:not(.slick-current) .source img {-->
<!--  opacity: 0.4;-->
<!--}-->

<!--.slick-slide[aria-hidden="true"] .source img {-->
<!--  opacity: 0.1;-->
<!--}-->

<!--.slick-slide.slick-current {-->
<!--  z-index: 2;-->
<!--  position: relative;-->
<!--}-->

<!--.slick-slide.slick-current .source img {-->
<!--  padding: 0;-->
<!--  opacity: 1;-->
<!--}-->

<!--.slick-prev::before,-->
<!--.slick-next::before {-->
<!--  content: "";-->
<!--}-->

<!--.btn-circle.arrow {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: center;-->
<!--}-->

<!--.btn-circle.slick-prev {-->
<!--  top: 110px;-->
<!--  left: 70%;-->
<!--}-->

<!--.btn-circle.slick-next {-->
<!--  bottom: 40px;-->
<!--  left: 70%;-->
<!--}-->

<!--.btn-circle.arrow span {-->
<!--  width: 48px;-->
<!--  height: 22px;-->
<!--  display: inline-block;-->
<!--  position: absolute;-->
<!--  background-repeat: no-repeat;-->
<!--  background-origin: initial;-->
<!--  background-clip: initial;-->
<!--  background-size: 100% auto;-->
<!--  background-position: center;-->
<!--}-->

<!--.btn-circle.slick-prev span {-->
<!--  -webkit-transform: rotate(180deg);-->
<!--  transform: rotate(180deg);-->
<!--}-->

<!--/* &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; */-->

<!--.fp-tableCell {-->
<!--  position: relative;-->
<!--}-->

<!--.section:not(.gallery) .content,-->
<!--.section-sub .content {-->
<!--  max-width: 98%;-->
<!--  max-width: 760px;-->
<!--  margin: auto;-->
<!--  position: relative;-->
<!--}-->

<!--.section .wrapper-data {-->
<!--  width: 100%;-->
<!--  margin-top: 20px;-->
<!--}-->

<!--@media (min-width: 1200px) {-->
<!--  .section.top .fp-tableCell {-->
<!--    width: calc(100vw - 250px);-->
<!--  }-->
<!--}-->
<!--</style>-->
